import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { ManageTradeMenu, LoaderWrapper } from "../../../components";
import { withAppLayout } from "../../../hoc";
import { MANAGE_TRADE_MENU } from "../../../utils";
import { ManageTradeRoutes } from "../../../routes";
import {
  ManageTradeProvider,
  manageTradeStore,
  setManageTradeSelectedMenu,
} from "../../../contexts";

export const ManageTrade = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageTradeStore);
  const { isFetching } = get(state, "api", {});
  const flow = get(state, "flow");

  useEffect(() => {
    dispatch(setManageTradeSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const isLoading = get(state, "isLoading");

  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col className="manage-company-column manage-menu-items">
            <div className="company-name-component">{""}</div>
            <ManageTradeMenu
              menuList={MANAGE_TRADE_MENU}
              selectedMenu={get(state, "selectedMenu")}
              flow={flow}
            />
          </Col>
          <Col className="h-100 manage-menu-content">
            <ManageTradeRoutes />
          </Col>
        </Row>
      </Col>
    </LoaderWrapper>
  );
};

const ManageTradeWithProvider = (props) => {
  return (
    <ManageTradeProvider>
      <ManageTrade {...props} />
    </ManageTradeProvider>
  );
};

export default withAppLayout(ManageTradeWithProvider);
